import { render } from "./DashboardNew.vue?vue&type=template&id=67a86460&scoped=true"
import script from "./DashboardNew.vue?vue&type=script&lang=js"
export * from "./DashboardNew.vue?vue&type=script&lang=js"

import "./DashboardNew.vue?vue&type=style&index=0&id=67a86460&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a86460"]])

export default __exports__